import { useGetAllPointOfInterestTemplatesQuery } from '@/__generated__/graphql';
import { useGetStructureId } from './useGetStructureId';

const useFetchTemplatesByType = () => {
  const structureId = useGetStructureId();

  const allTemplatesQueryResult = useGetAllPointOfInterestTemplatesQuery({
    variables: {
      structureId,
    },
    fetchPolicy: 'cache-first',
    skip: !structureId,
  });

  return {
    data: allTemplatesQueryResult.data,
    loading: allTemplatesQueryResult.loading,
    error: allTemplatesQueryResult.error,
  };
};

export default useFetchTemplatesByType;
